<template>
    <div class="wizard-radio-tags radio-tags"
            :class="[bemFacets, { 'wizard-radio-tags__bottom-spacing': bottomSpacing }]">
        <h2 class="u-reset u-reset__h4" v-if="$scopedSlots.title">
            <slot name="title"/>
        </h2>
        <p
                class="radio-tags--description"
                :class="{'radio-tags--description__is-monochrome-black': isMonochromeBlack}"
                v-if="$scopedSlots.description">
            <slot name="description"/>
        </p>

        <ul class="radio-tags--tags-list u-reset">
            <li class="radio-tags--tags-item" v-for="(choice) in choices" :key="choice.value">
                <label class="radio-tags--tags-tag" :for="name + '_' + choice.value">
                    <input class="radio-tags--input"
                            :name="name"
                            type="radio"
                            :value="choice.value"
                            :inital-value="initialValue"
                            :checked="value === choice.value || initialValue === choice.value"
                            :id="name + '_' + choice.value"
                            @change="onUpdate({ key: toggleId, value: choice.value })">
                    <span class="radio-tags--tags-tag-text">
                        {{ choice.label }}
                    </span>
                    <div class="radio-tags--tags-tag-description" v-if="choice.description">
                        {{ choice.description }}
                    </div>
                </label>
            </li>
        </ul>

        <div class="wizard-radio-tags__messages" v-if="$scopedSlots.messages">
            <slot name="messages"/>
        </div>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { mapActions, mapState } from 'vuex';

    export default {
        components: {},
        mixins: [
            bemMixin('wizard-radio-tags'),
        ],
        props: {
            name: {
                type: String,
                required: true,
            },
            initialValue: {
                type: [Boolean, String, Number],
                required: true,
            },
            toggleId: {
                type: String,
                default: null,
            },
            choices: {
                type: Array,
                default: () => [],
            },
            siblingsField: {
                type: Array,
                required: false,
                default: () => [],
            },
            isMonochromeBlack: {
                type: Boolean,
                default: false,
            },
            bottomSpacing: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapState('wizard', ['useEnroleeBillingAddress', 'useBillingAddressLegalGuardian1', 'useBillingAddressLegalGuardian2']),

            value() {
                return this.siblingsField ? this[this.toggleId] : this.initialValue;
            },
        },
        methods: {
            ...mapActions('wizard', ['updateWizardToggle', 'updateRadioTagGroups']),
            onUpdate(data) {
                if (!this.toggleId) {
                    return;
                }
                if (this.siblingsField) {
                    this.updateRadioTagGroups({
                        key: this.toggleId,
                        value: data.value,
                        siblingsField: this.siblingsField,
                    });
                    return;
                }
                this.updateWizardToggle(data);
            },
        },
        mounted() {
            this.updateWizardToggle({ key: this.toggleId, value: this.initialValue });
        },
    };
</script>
